import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Problems() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto ">
            <h2>
              The <span style={{ color: "#49A950" }}>Problem</span>
            </h2>
            <p>
              The biggest concern was to be able to merge effortless user
              experience without compromising on the detailed accuracy and
              functionality of the app. The idea was to facilitate users and
              sort out technical features that would allow accurate tracings of
              pickup and dropoff locations.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center offset-lg-1 "
          >
            <StaticImage
              src="../../../images/case-studies/kush-me/tek_img_02.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={790}
              height={590}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Problems;
